import React, {PureComponent} from 'react'
import injectStyles from "react-jss"
import { connect } from 'react-redux'
import ExtraNav from "./ExtraNav"
import Header from "./Header"
import MainMenu from "./MainMenu"
import BottomNav from "./BottomNav"
import {getUniversalMenuIsOpen, getUniversalMenuAccountMenuIsOpen} from "../../selectors"
import {closeMenu} from "../../actions"
import EditionNav from './EditionNav'

class UniversalNav extends PureComponent {

    render() {
        const {classes, open, accountOpen, handleCloseMenu} = this.props;

        return <header>
            <ExtraNav/>
            <header className={classes.header}>
                <Header/>
                <MainMenu />
            </header>
            {(open || accountOpen) && <div className={classes.block} onClick={handleCloseMenu}></div>}
            <BottomNav />
            <EditionNav />
        </header>
    }
}

const mapStateToProps = (state) => {
    return {
        open: getUniversalMenuIsOpen(state),
        accountOpen: getUniversalMenuAccountMenuIsOpen(state)
    }
}


function mapDispatchToProps(dispatch) {
    return {
        handleCloseMenu: () => {
            dispatch(closeMenu())
        },
    }
}


export default injectStyles((theme) => ({
    header: {
        width: '100%',
        background: theme.colors.universalNav,
        lineHeight: '1em',
        textAlign: 'center',
        display: 'block',
        color: theme.colors.white,
        zIndex: theme.zIndex.menu,

        [theme.breakpoint('laptop')]: {
            position: 'relative',
            top: 'inherit',
            bottom:  'inherit',
        },
    },
    block: {
        display: 'none',
        [theme.breakpoint('laptop')]: {
            display: 'block',
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.menu - 1,
            backgroundColor: 'rgba(0,0,0,.1)'
        }
    },
}))(connect(mapStateToProps, mapDispatchToProps)(UniversalNav))







// WEBPACK FOOTER //
// ./src/components/UniversalNav/UniversalNav.js